import { ClockCircleOutlined } from '@ant-design/icons';
import { Timeline, Card, List, Typography, Collapse, Divider } from 'antd';
import React from 'react';
const { Meta } = Card;
const { Panel } = Collapse;
const { Text, Link } = Typography;

const data_devops = [
    '-Built custom managesieve filter protocol server for Cpanel Mail Servers.',
    '-Changed Metrics collection strategy from adhoc collection to collect USERED Metrics collections. Defined SLI, SLO and improving alerts.',
    '-Designed Mail migration architecture and successfully completed migrations with zero downtime.',
    '-Successfuly designed and built AntiSpam, Ratelimiters, IPReputation/WarmUPFrameworks, IP Blacklist Monitoring and PushNotification Framework for Infrastructure.',
    '-Built Log Pipelines(ELK,rsyslog), Metricscollectors(python/shell) and Monitoring/Backupscripts : Migrated Large MySQL tables with zerodowntime using percona and gh-ost tools.'
]

const data_devops_intern = [
  '-Built Benchmarking Framework(A wrapper over FIO and sar),that helps to benchmark hardware performance before deploying any Application on VMs(Python , Mongo , Flask) ',
  '-POC - HAProxy and Varnish SAAS for developers (Kubernetes, Python, KONG)'
]

const data_senior_devops = [
  '-Introduced Golang to Team | Developed Protocol middleware’s in golang as well as some bulk data collection tools.',
  '-Mentored and motivated other team members to start using golang.',
  '-Worked and guided juniors to build a data collection tool to collect bulk amount of data from internet (using container fleet , streamlit and Amazon S3)',
  '-Built Big Data Integrations(Athena/S3/Glue/Python) for mail infrastructures which enables Support to troubleshoot and Business to Analyse.',
  '-Worked on terraform code and saltstack configurations to replicate whole infrastructure to another region (including ECS components, LBs DNS, VMs, Queues, IAM)',
  '-Take part in Reviews, Debugging Issues, Architecture Discussions, Interviews'
]

const Career = () => {
    return(
 <>
  <Timeline mode="left" reverse="True">
    
    <Timeline.Item color="green">
        <Card>
        <Collapse  ghost="True">
          <Panel header="DevOps Engineering Intern | Media.net - Directi (Jan 2018 – July 2018)">
          <List
      
            dataSource={data_devops_intern}
            renderItem={item => (
            <List.Item>
            <Text code="True">{item}</Text>
            </List.Item>

            )}/>
          </Panel>

        </Collapse>
        </Card>
        </Timeline.Item>
    {/* <Timeline.Item
      dot={
        <ClockCircleOutlined
          style={{
            fontSize: '16px',
          }}
        />
      }
    >
      
    </Timeline.Item> */}
    
    <Timeline.Item color="blue">
        <Card>
        
    <Collapse  ghost="True">
      <Panel header="DevOps Engineer | Flock - Directi (August 2018 – August 2020) - Bengaluru, India">
      <List
   
        dataSource={data_devops}
        renderItem={item => (
        <List.Item>
        <Text code='True'>{item}</Text>
        </List.Item>

        )}/>
      </Panel>

    </Collapse>
        
        </Card>
    </Timeline.Item>
    <Timeline.Item color="yellow">
    <Card>
        <Collapse  ghost="True">
          <Panel header="Senior DevOps Engineer Nova/Flock - Directi : (August 2020 – May 2022) Bengaluru, India">
          <List
      
            dataSource={data_senior_devops}
            renderItem={item => (
            <List.Item>
            <Text code='True'>{item}</Text>
            </List.Item>

            )}/>
          </Panel>

        </Collapse>
        </Card>
    </Timeline.Item>
  </Timeline>
  </>
    )
};

export default Career;